import { forwardRef, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import MDTypography from "../MDTypography";
import pxToRem from "../../Asset/theme/functions/pxToRem";
interface IMDSelect {
  name: string;
  onChange: any;
  disabled?: boolean;
  label: string;
  fullWidth?: boolean;
  enumi: Object;
  defaultValue: any;
  error: boolean | undefined;
  helperText: string | false | undefined;
}
// Custom styles for MDInput
const MDSelect = ({
  name,
  onChange,
  enumi,
  fullWidth,
  label,
  disabled,
  defaultValue,
  error,
  helperText,
}: IMDSelect) => {
  const { t, i18n } = useTranslation();
  var enumArray: { name: string; id: number }[] = [];

  Object.entries(enumi).forEach(([key, value]) => {
    if (typeof value === "number") enumArray.push({ name: key, id: value });
  });
  const handleChange = (event: any) => {
    if (event.target.value === "none") {
      return onChange(null);
    }
    return onChange(event.target.value);
  };

  return (
    <FormControl fullWidth={fullWidth ?? false}>
      <InputLabel htmlFor="grouped-native-select">{label}</InputLabel>
      <Select
        name={name}
        disabled={disabled ?? false}
        onChange={handleChange}
        native
        defaultValue={defaultValue}
        id="grouped-native-select"
        label={label}
      >
        <option  value={"none"}>بدون انتخاب</option>
        {enumArray.map((e) => (
          <option key={e.id} value={e.id}>
            {t(e.name)}
          </option>
        ))}
      </Select>
      {error && (
        <MDTypography
          color={"error"}
          fontSize={pxToRem(12)}
          sx={{ margin: "0 12px" }}
        >
          {helperText}
        </MDTypography>
      )}
    </FormControl>
  );
};

export default MDSelect;
